const getEnv = (key) => {
  return process.env[key] || (window.env && window.env[key]) || undefined;
};

export default getEnv;
